{
    "DATE": {
        "YESTERDAY": "Yesterday",
        "TODAY": "Today",
        "TOMORROW": "Tomorrow"
    },
    "ENUM": {
        "CLIENT_TYPE": {
            "DEBT_MEDIATION": {
                "LABEL": "Debt mediation",
                "ICON": "debt-mediation"
            },
            "FINANCIAL_MANAGEMENT": {
                "LABEL": "Financial management",
                "ICON": "guardianship"
            },
            "SOCIAL_RENT": {
                "LABEL": "Social rent",
                "ICON": "social-rent"
            },
            "BUDGET_GUIDANCE": {
                "LABEL": "Budget guidance",
                "ICON": "budget-management"
            },
            "RENT": {
                "LABEL": "Rent",
                "ICON": "rent"
            },
            "PCSW": {
                "LABEL": "PCSW",
                "ICON": "pcsw"
            }
        },
        "BANK_ACCOUNT_OWNER_TYPE": {
            "CLIENT": {
                "ICON": "clients"
            },
            "OFFICE": {
                "ICON": "office-account"
            }
        },
        "BANK_ACCOUNT_TYPE": {
            "BASE": {
                "LABEL": "Base account"
            },
            "RESERVE": {
                "LABEL": "Reserve account"
            },
            "SAVINGS": {
                "LABEL": "Savings account"
            },
            "ALLOWANCE": {
                "LABEL": "Allowance account"
            },
            "SECURITY": {
                "LABEL": "Security account"
            },
            "VAPH": {
                "LABEL": "VAPH account"
            },
            "INVEST": {
                "LABEL": "Investment account"
            }
        },
        "LANGUAGE": {
            "NL": "Dutch",
            "FR": "French",
            "EN": "English"
        },
        "MOBILE_APP_USER_LOGIN_TYPE": {
            "PHONE": {
                "LABEL": "Mobile number"
            },
            "EMAIL": {
                "LABEL": "E-mail"
            }
        }
    },
    "TOAST": {
        "INFO": {
            "UPDATE_AVAILABLE": {
                "TITLE": "Update available!",
                "MESSAGE": "Click here or refresh the page to load the new version."
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Document is being generated",
                "MESSAGE": "You will be notified when the document is ready."
            }
        },
        "ERROR": {
            "UNKNOWN": {
                "TITLE": "Unknown error"
            },
            "BAD_REQUEST": {
                "TITLE": "Bad request"
            },
            "FORBIDDEN": {
                "TITLE": "Forbidden"
            },
            "NOT_FOUND": {
                "TITLE": "Not found"
            },
            "UPLOAD_DOCUMENTS": {
                "TITLE": "Upload of documents failed"
            },
            "CREATE_ACTIVE_DEBT_DOSSIERS_REPORT": {
                "TITLE": "Generating report failed"
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Generating document failed"
            }
        },
        "SUCCESS": {
            "ADD_CLIENT": {
                "TITLE": "Client successfully created"
            },
            "INFO_SAVED": {
                "TITLE": "Basic info has been saved"
            },
            "CLIENT_ACCOUNTS_SAVED": {
                "TITLE": "Bank accounts have been saved"
            },
            "ACCOUNT_CLIENT_SETTINGS_SAVED": {
                "TITLE": "Client settings have been saved"
            },
            "TRANSACTION": {
                "CATEGORY": {
                    "SAVED": {
                        "TITLE": "Category has been saved",
                        "ALL_CLIENTS": {
                            "TITLE": "Category has been saved",
                            "MESSAGE": "The category was set on all accounts of the linked client. The processing of the other accounts was started in the background."
                        }
                    }
                }
            },
            "CLIENT_ARCHIVED": {
                "TITLE": "Client has been archived"
            },
            "CLIENT_RESTORED": {
                "TITLE": "Client has been restored"
            },
            "PDF_EXPORTED": {
                "TITLE": "Your PDF export has been downloaded."
            },
            "XLSX_EXPORTED": {
                "TITLE": "Your Excel export has been downloaded."
            },
            "BANK_ACCOUNT_ARCHIVED": {
                "TITLE": "Account has been archived"
            },
            "BANK_ACCOUNT_RESTORED": {
                "TITLE": "Account has been restored"
            },
            "DOCUMENT_DOWNLOADED": {
                "TITLE": "Document has been downloaded"
            },
            "DOCUMENT_RESPONSE_ADDED": {
                "TITLE": "Payment request has been answered"
            },
            "TRANSACTION_TAGS_SAVED": {
                "TITLE": "Tags have been updated"
            },
            "DOSSIER_SAVED": {
                "TITLE": "Dossier has been saved"
            },
            "DIVIDEND_CREATED": {
                "TITLE": "Payments have been created"
            },
            "RB_DOCUMENT_CREATED": {
                "TITLE": "Document generation is in progress. The document will be added to the list of documents once completed"
            },
            "UPLOAD_DOCUMENTS": {
                "TITLE": "Documents have been uploaded"
            },
            "PAYMENT_SAVED": {
                "TITLE": "The payment has been saved"
            },
            "DOCUMENT_RENAMED": {
                "TITLE": "Document has been renamed"
            },
            "DOCUMENT_DELETED": {
                "TITLE": "Documents have been deleted"
            },
            "DOCUMENT_UPDATED": {
                "TITLE": "Document has been updated"
            },
            "PAYMENT_DELETED": {
                "TITLE": "Payment has been deleted"
            },
            "CLIENT_APPLICATION_INVITATION": {
                "TITLE": "Invitation has been sent"
            },
            "ACCOUNT_USER_SAVED": {
                "TITLE": "Personal data has been updated"
            },
            "PASSWORD_SAVED": {
                "TITLE": "Password has been updated"
            },
            "OFFICE_SAVED": {
                "TITLE": "Office has been updated"
            },
            "OFFICE_USER_ADDED": {
                "TITLE": "User has been added",
                "MESSAGE": "An invitation was sent via e-mail."
            },
            "OFFICE_USER_UPDATED": {
                "TITLE": "User has been updated"
            },
            "REDIRECTING_TO_FINANCIAL_INSTITUTION": {
                "TITLE": "You will be redirected to the bank"
            },
            "REDIRECTING_TO_ISABEL": {
                "TITLE": "You are redirected to Isabel 6"
            },
            "CREDITORS_IMPORTED": {
                "TITLE": "Creditors have been imported"
            },
            "CREATE_ACTIVE_DEBT_DOSSIERS_REPORT": {
                "TITLE": "Report has been generated"
            },
            "DOCUMENT_ASSIGNED": {
                "TITLE": "Documents have been assigned"
            },
            "NOTIFICATIONS_PROCESSED": {
                "TITLE": "Notifications have been closed"
            },
            "PAYMENTS_SUBMITTED": {
                "TITLE": "Payments have been submitted to Isabel 6"
            },
            "PASSWORD_UPDATED": {
                "TITLE": "Check your email",
                "MESSAGE": "You will receive an email with instructions to set a new password."
            },
            "OFFICE_TRANSACTION_CATEGORY_ADDED": {
                "TITLE": "Category added"
            },
            "OFFICE_TRANSACTION_CATEGORY_UPDATED": {
                "TITLE": "Category saved"
            },
            "OFFICE_TRANSACTION_CATEGORY_DELETED": {
                "TITLE": "Category deleted"
            },
            "BUDGET_SAVED": {
                "TITLE": "Budget saved",
                "MESSAGE": "The budget was saved successfully."
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Document has been generated",
                "MESSAGE": "The document is ready and has been added to the list.",
                "LINK": "View"
            }
        },
        "WARNING": {
            "PDF_NOT_EXPORTED": {
                "TITLE": "PDF export is limited to 3000 transactions. Adjust your filters."
            },
            "XLSX_NOT_EXPORTED": {
                "TITLE": "Excel export is limited to 3000 transactions. Adjust your filters."
            },
            "MAX_UPLOAD_FILE_SIZE": {
                "TITLE": "Maximum file size exceeded",
                "MESSAGE": "Only files smaller than 20MB can be added."
            },
            "MAX_UPLOAD_REQUEST_SIZE": {
                "TITLE": "Maximum upload size exceeded",
                "MESSAGE": "The total size of an upload must be less than 200 MB."
            },
            "FILE_TYPE": {
                "TITLE": "File type is not supported"
            }
        }
    },
    "LOGIN": {
        "HEADER": "Login",
        "FORM": {
            "FIELD": {
                "USERNAME": {
                    "PLACEHOLDER": "Email",
                    "ERROR": {
                        "REQUIRED": "Required",
                        "EMAIL": "Invalid email address"
                    }
                },
                "PASSWORD": {
                    "PLACEHOLDER": "Password",
                    "ERROR": {
                        "REQUIRED": "Required",
                        "INVALID": "Email and/or password are incorrect"
                    }
                }
            },
            "BUTTON": {
                "SUBMIT": {
                    "LABEL": "Login"
                }
            }
        },
        "CC_ACCESS": {
            "MESSAGE": "You are about to login to the office &quot;<strong>{{ office }}</strong>&quot;"
        },
        "SUCCESS": {
            "TITLE": "Logged in",
            "LINK": "Click here if you are not redirected automatically"
        },
        "ERROR": {
            "TITLE": "Login error",
            "BUTTON": "Log in again"
        }
    },
    "APP": {
        "SIDENAV": {
            "MENU": {
                "ITEM": {
                    "DASHBOARD": {
                        "LABEL": "Dashboard",
                        "TOOLTIP": "Dashboard"
                    },
                    "CLIENTS": {
                        "LABEL": "Clients",
                        "TOOLTIP": "Clients"
                    },
                    "MESSAGES": {
                        "LABEL": "Messages",
                        "TOOLTIP": "Messages"
                    },
                    "CONTACTS": {
                        "LABEL": "Contacts",
                        "TOOLTIP": "Contacts"
                    },
                    "BANK_ACCOUNTS": {
                        "LABEL": "Bank accounts",
                        "TOOLTIP": "Bank accounts"
                    },
                    "PAYMENTS": {
                        "LABEL": "Payments",
                        "TOOLTIP": "Payments"
                    },
                    "NOTIFICATIONS": {
                        "LABEL": "Notifications",
                        "TOOLTIP": "Notifications"
                    },
                    "OTHER": {
                        "LABEL": "Other",
                        "TOOLTIP": "Other",
                        "MENU": {
                            "ITEM": {
                                "ACTIONS": {
                                    "LABEL": "Actions",
                                    "TOOLTIP": "Actions"
                                },
                                "ARCHIVE": {
                                    "MENU": {
                                        "ITEM": {
                                            "CLIENTS": {
                                                "LABEL": "Clients archive",
                                                "TOOLTIP": "Clients archive"
                                            },
                                            "BANK_ACCOUNTS": {
                                                "LABEL": "Bank accounts archive",
                                                "TOOLTIP": "Bank accounts archive"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "OFFICE": {
                        "LABEL": "My office",
                        "TOOLTIP": "My office"
                    },
                    "PROFILE": {
                        "LABEL": "My profile",
                        "TOOLTIP": "My profile"
                    },
                    "SETTINGS": {
                        "LABEL": "Settings",
                        "TOOLTIP": "Settings"
                    },
                    "DOCUMENTS": {
                        "LABEL": "Documents",
                        "TOOLTIP": "Documents"
                    }
                },
                "ACTION": {
                    "LOGOUT": {
                        "LABEL": "Logout",
                        "TOOLTIP": "Logout"
                    },
                    "ISABEL": {
                        "TOOLTIP": "Isabel 6 Customer Zone"
                    },
                    "COLLAPSE": {
                        "LABEL": "Collapse",
                        "TOOLTIP": "Expand"
                    },
                    "HELPDESK": {
                        "LABEL": "Helpdesk",
                        "TOOLTIP": "Helpdesk",
                        "URL": "https://roov.app/en/helpdesk/1"
                    }
                }
            }
        },
        "ACTIONS": {
            "HEADER": {
                "LABEL": "Actions"
            }
        },
        "ARCHIVE": {
            "BANK_ACCOUNTS": {
                "HEADER": {
                    "LABEL": "Bank accounts archive"
                }
            },
            "CLIENTS": {
                "HEADER": {
                    "LABEL": "Clients archive"
                }
            }
        },
        "BANK_ACCOUNTS": {
            "HEADER": {
                "LABEL": "Bank accounts"
            },
            "FILTER": {
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Search"
                },
                "LINKED": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "All accounts"
                        },
                        "TRUE": {
                            "LABEL": "Linked"
                        },
                        "FALSE": {
                            "LABEL": "Unlinked"
                        }
                    }
                },
                "WITH_WARNING": {
                    "LABEL": "With warning"
                },
                "FINANCIAL_INSTITUTION": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "All financial institutions"
                        }
                    }
                }
            },
            "BUTTON": {
                "ADD": {
                    "LABEL": "Add account"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "FINANCIAL_INSTITUTION": {
                        "HEADER": {
                            "LABEL": "Financial institution"
                        }
                    },
                    "LABEL": {
                        "HEADER": {
                            "LABEL": "Account"
                        }
                    },
                    "IBAN": {
                        "HEADER": {
                            "LABEL": "Account number"
                        }
                    },
                    "BALANCE": {
                        "HEADER": {
                            "LABEL": "Balance"
                        }
                    },
                    "SYNCHRONIZED_AT": {
                        "HEADER": {
                            "LABEL": "Synchronized"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Linked to"
                        }
                    },
                    "LATEST_TRANSACTION": {
                        "HEADER": {
                            "LABEL": "Latest transaction"
                        }
                    }
                },
                "EMPTY": "No accounts found"
            },
            "WARNINGS": {
                "ARCHIVED": "Archived",
                "AUTH_INVALID": "Invalid authorization",
                "EXPIRING": "Authorization expires",
                "MOVED_TO_ISABEL": "Bank migrated to Isabel Connect",
                "TECHNICAL_FAILURE": "Temporary technical failure",
                "NOT_FOUND_ISABEL": "Not available through Isabel Connect",
                "BLOCKED": ""
            },
            "API_PRODUCT": {
                "ISABEL": {
                    "TOOLTIP": "Linked via Isabel Connect"
                },
                "IMPORT": {
                    "TOOLTIP": "Imported, not actively linked"
                }
            }
        },
        "CLIENTS": {
            "HEADER": {
                "LABEL": "Clients"
            },
            "FILTER": {
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Search"
                },
                "CLIENT_TYPE": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "All client types"
                        }
                    }
                },
                "OPEN_NOTIFICATIONS_ONLY": {
                    "LABEL": "Open notifications only"
                },
                "USER": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "All clients"
                        },
                        "MY": {
                            "LABEL": "My clients"
                        },
                        "OTHER": {
                            "LABEL": "Clients of"
                        }
                    }
                }
            },
            "BUTTON": {
                "ADD": {
                    "LABEL": "Add client"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "NAME": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    },
                    "LAST_NOTIFICATION": {
                        "HEADER": {
                            "LABEL": "Last notification"
                        },
                        "SUBTITLE": "{{count}} open"
                    },
                    "BANK_ACCOUNTS": {
                        "HEADER": {
                            "LABEL": "Bank accounts"
                        },
                        "WARNING": {
                            "TOOLTIP": "This bank account is about to expire"
                        }
                    },
                    "BALANCE": {
                        "HEADER": {
                            "LABEL": "Balance"
                        }
                    }
                },
                "EMPTY": "No clients found"
            },
            "CLIENT": {
                "BREADCRUMB": {
                    "LABEL": "Clients"
                },
                "BANK_ACCOUNTS": {
                    "HEADER": {
                        "LABEL": "Bank accounts"
                    },
                    "EMPTY": "No bank accounts available"
                },
                "TAB": {
                    "NOTIFICATIONS": {
                        "LABEL": "Notifications",
                        "ONLY_UNPROCESSED": {
                            "LABEL": "Only open notifications"
                        },
                        "TABLE": {
                            "COLUMN": {
                                "ACCOUNT": {
                                    "HEADER": {
                                        "LABEL": "Bank account"
                                    }
                                },
                                "NOTIFICATION": {
                                    "HEADER": {
                                        "LABEL": "Notification"
                                    },
                                    "ACCEPTED": "Accept",
                                    "DECLINED": "Decline"
                                },
                                "CLOSED": {
                                    "HEADER": {
                                        "LABEL": "Closed"
                                    }
                                }
                            },
                            "EMPTY": "No notifications found"
                        },
                        "PROCESS_NOTIFICATIONS": {
                            "LABEL": "Close all"
                        }
                    },
                    "INFO": {
                        "LABEL": "Basic info"
                    },
                    "DOSSIER": {
                        "LABEL": "Dossier"
                    },
                    "DOCUMENTS": {
                        "LABEL": "Documents"
                    },
                    "APPLICATION": {
                        "LABEL": "Client app"
                    },
                    "DOSSIER_DEBT_MEDIATION": {
                        "LABEL": "Debt mediation"
                    },
                    "DOSSIER_FINANCIAL_MANAGEMENT": {
                        "LABEL": "Administration"
                    },
                    "BUDGET": {
                        "LABEL": "Budget"
                    }
                },
                "SET_ARCHIVED_STATUS": {
                    "DIALOG": {
                        "TITLE": "Archive",
                        "STATUS": {
                            "TITLE": "Status",
                            "ACTIVE": "Active",
                            "ARCHIVED": "Archived on {{ date }}"
                        },
                        "ACTION": {
                            "TITLE": "Action",
                            "ACTIVE": "Archive",
                            "ARCHIVED": "Restore"
                        },
                        "INFO": {
                            "ARCHIVED": "Restoring a client involves:\n<ul>\n<li>The client is displayed again in the list of active clients.</li>\n<li>Basic info and dossier can be modified again.</li>\n<li>Documents can be uploaded or generated again.</li>\n<li>A new link to the client app can be made (a possible previous link is not restored).</li>\n<li>It is again possible to link or unlink bank accounts to or from this client.</li>\n<li>Linked bank accounts remain archived, but can be restored separately.</li>\n<li>New notifications for this client may pop up again.</li>\n</ul>",
                            "ACTIVE": "Archiving a client involves:\n<ul>\n<li>The client is no longer shown in the list of active clients.</li>\n<li>Basic info and dossier can no longer be modified.</li>\n<li>Documents can no longer be uploaded or generated.</li>\n<li>Any link to the client app will be broken and account info thus no longer shared.</li>\n<li>It is no longer possible to link or unlink bank accounts to or from this client.</li>\n<li>All linked bank accounts are archived and thus no longer synchronized.</li>\n<li>All open notifications are closed and no new notifications are created.</li>\n</ul>"
                        }
                    }
                }
            },
            "ADD_CLIENT_DIALOG": {
                "TITLE": "New client",
                "CONTENT": {
                    "INFO": {
                        "HEADER": "Basic info"
                    },
                    "TYPE": {
                        "HEADER": "Type",
                        "FORM": {
                            "FIELD": {
                                "TYPE": {
                                    "ERROR": {
                                        "REQUIRED": "Required"
                                    }
                                }
                            }
                        }
                    }
                },
                "BUTTON": {
                    "CONFIRM": {
                        "LABEL": "Confirm"
                    },
                    "CANCEL": {
                        "LABEL": "Cancel"
                    }
                }
            },
            "CLIENT_INFO": {
                "EDIT": {
                    "DIALOG": {
                        "FIELD": {
                            "EMAIL": {
                                "ERROR": {
                                    "REQUIRED": "Required",
                                    "EMAIL": "Invalid email address"
                                }
                            },
                            "FIRSTNAME": {
                                "ERROR": {
                                    "REQUIRED": "Required"
                                }
                            },
                            "SSN": {
                                "ERROR": {
                                    "INPUT_MASK": "Invalid national registration number"
                                }
                            },
                            "DATE_OF_BIRTH": {
                                "ERROR": {
                                    "MAT_DATEPICKER_PARSE": "Invalid date",
                                    "MAT_DATEPICKER_MAX": "Future dates are not allowed",
                                    "INPUT_MASK": "Invalid date"
                                }
                            }
                        },
                        "TITLE": "Basic info",
                        "ERROR": {
                            "REQUIRED": "Not all required fields have been completed",
                            "EMAIL": "Invalid email address",
                            "INPUT_MASK": "Invalid national registration number",
                            "MAT_DATEPICKER_PARSE": "Invalid date",
                            "MAT_DATEPICKER_MAX": "Future dates are not allowed"
                        }
                    },
                    "LABEL": "Edit"
                },
                "PERSONAL_INFO": {
                    "FIRSTNAME": "First name",
                    "LASTNAME": "Last name",
                    "STREET": "Street",
                    "HEADER": "Personal data",
                    "NUMBER": "No. / box",
                    "SSN": "National registration no.",
                    "POSTALCODE": "Postal code",
                    "BIRTHDATE": "Birthdate",
                    "CITY": "Municipality",
                    "PHONE": "Phone",
                    "EMAIL": "Email",
                    "LANGUAGE": "Language"
                },
                "FAMILY_INFO": {
                    "HEADER": "Info partner & children",
                    "FIRSTNAME": "First name",
                    "LASTNAME": "Last name",
                    "PHONE": "Phone",
                    "EMAIL": "Email",
                    "CHILDREN": "Children"
                },
                "REMARKS": {
                    "HEADER": "Remarks",
                    "PLACEHOLDER": "Type here"
                }
            },
            "EDIT_ACCOUNTS": {
                "DIALOG": {
                    "TITLE": "Bank accounts",
                    "ACCOUNTS_MANAGED_BY": "Accounts managed by {{name}}",
                    "OFFICE_ACCOUNT_INFO": "Enter account number or select a linked account",
                    "CLIENT_ACCOUNT_INFO": "Enter account number",
                    "ADD_ACCOUNT": "Add account",
                    "LINKED": "Linked through client app",
                    "NOT_LINKED": "Not linked",
                    "TYPE": {
                        "LABEL": "Type"
                    },
                    "LABEL": {
                        "LABEL": "Label"
                    },
                    "IBAN": {
                        "LABEL": "IBAN",
                        "ERROR": {
                            "REQUIRED": "Required",
                            "INPUT_MASK": "Invalid IBAN",
                            "IBAN": "Invalid IBAN",
                            "LINKED": "Already linked to {{param}}",
                            "DUPLICATE": "This IBAN has already been used"
                        }
                    },
                    "ERROR": {
                        "REQUIRED": "Not all required fields have been completed",
                        "IBAN": "Invalid IBAN",
                        "LINKED": "IBAN already linked to other client",
                        "DUPLICATE": "This IBAN has already been used",
                        "ADD_ENABLED": "Add the account before you can confirm"
                    },
                    "ACCOUNT": {
                        "LABEL": "Account"
                    }
                }
            },
            "DOSSIER_INFO": {
                "GENERAL": {
                    "HEADER": "General",
                    "START_DATE": {
                        "LABEL": "Start date"
                    },
                    "END_DATE": {
                        "LABEL": "End date"
                    },
                    "DOSSIER_NUMBER": {
                        "LABEL": "Dossier number"
                    },
                    "BALANCE_THRESHOLD": {
                        "LABEL": "Threshold for “Balace above …” notifications"
                    },
                    "HOMOLOGATION_DATE": {
                        "LABEL": "Date of ruling homologation"
                    },
                    "ADMISSIBILITY_DATE": {
                        "LABEL": "Date of decision of admissibility"
                    },
                    "LABOUR_COURT": {
                        "LABEL": "Labour court",
                        "DEFAULT": "Default labour court"
                    },
                    "DOCKET_NUMBER": {
                        "LABEL": "Docket number"
                    },
                    "JUSTICE_PEACE": {
                        "LABEL": "Justice of the peace",
                        "DEFAULT": "Default justice of the peace"
                    },
                    "START_DATE_PLAN": {
                        "LABEL": "Plan start date"
                    },
                    "END_DATE_PLAN": {
                        "LABEL": "Plan end date"
                    },
                    "DEBT_MEDIATOR": {
                        "LABEL": "Debt mediator",
                        "DEFAULT": "Default debt mediator"
                    },
                    "ADMINISTRATOR": {
                        "LABEL": "Administrator",
                        "DEFAULT": "Default administrator"
                    },
                    "ASSIGNEE": {
                        "LABEL": "Dossier manager",
                        "NONE": {
                            "LABEL": "No dossier manager"
                        }
                    },
                    "START_DATE_REPORT": {
                        "LABEL": "Reporting start date"
                    }
                },
                "EDIT": {
                    "LABEL": "Edit",
                    "DIALOG": {
                        "FIELD": {
                            "END_DATE": {
                                "ERROR": {
                                    "NOT_BEFORE_START_DATE": "Before start date"
                                }
                            }
                        }
                    }
                },
                "FINANCIAL": {
                    "HEADER": "Financial situation",
                    "TOTAL_DEBT": {
                        "LABEL": "Total debt"
                    },
                    "MAIN_SUM": {
                        "LABEL": "Principal amount"
                    },
                    "INTEREST": {
                        "LABEL": "Interest"
                    },
                    "COSTS": {
                        "LABEL": "Costs"
                    },
                    "COURT_COSTS": {
                        "LABEL": "Court costs"
                    },
                    "INCREASES": {
                        "LABEL": "Increases"
                    },
                    "MONTHLY_INCOME": {
                        "LABEL": "Income / m"
                    },
                    "MONTHLY_EXPENSES": {
                        "LABEL": "Expenses / m"
                    },
                    "DIFFERENCE": "Difference"
                },
                "SETTLEMENT": {
                    "HEADER": "Settlement",
                    "TYPE": {
                        "LABEL": "Type",
                        "MONTHLY": "Monthly reserve",
                        "PERCENTAGE": "Percentage",
                        "BALANCE": "Balance settlement",
                        "MORATORIUM": "Moratorium",
                        "NONE": "None"
                    },
                    "MONTHLY": {
                        "LABEL": "Monthly reserve"
                    },
                    "PERCENTAGE": {
                        "LABEL": "Percentage"
                    },
                    "PERIODICITY": {
                        "LABEL": "Periodicity of payments (months)"
                    },
                    "START_DATE": {
                        "LABEL": "Start date of payment"
                    },
                    "END_DATE": {
                        "LABEL": "End date of payment"
                    },
                    "RETAINED_AMOUNT": {
                        "LABEL": "Agreed"
                    },
                    "SUMMARY": {
                        "TITLE": "Summary",
                        "COPY": {
                            "LABEL": "Copy"
                        },
                        "REPAYMENT": {
                            "MONTHLY_OR_PERCENTAGE": "Repayment of {{totalSumToPay}} ({{percentage}} of {{referenceAmount}}) over a period of {{period}}.",
                            "BALANCE": "Repayment of at most {{referenceAmount}} insofar as funds are available over a period of {{period}}.",
                            "MORATORIUM": "All measures are suspended."
                        },
                        "DIVIDEND": {
                            "MONTHLY_OR_PERCENTAGE": "A dividend of {{periodicAmountToPay}} will be paid {{periodicity}} to the creditors pro rata.",
                            "BALANCE": "A dividend will be paid {{periodicity}} to the creditors pro rata if funds are available."
                        },
                        "FIRST_DIVIDEND": {
                            "MONTHLY_OR_PERCENTAGE": "The first dividends will be paid on {{paymentStartDate}}.",
                            "BALANCE": "The first dividends may be paid on {{paymentStartDate}}."
                        },
                        "REFERENCE_AMOUNT": {
                            "TOTAL_DEBT": "the total debt",
                            "MAIN_SUM": "the main sums",
                            "RETAINED_AMOUNT": "the retained amounts"
                        },
                        "PERIOD": {
                            "YEARS": "{{years}} year(s)",
                            "YEARS_MONTHS": "{{years}} year(s) and {{months}} month(s)"
                        },
                        "PERIODICITY": {
                            "YEARLY": "annually",
                            "MONTHLY": "every {{months}} month(s)"
                        },
                        "NONE": "The settlement arrangement has not yet been drawn up.",
                        "INCOMPLETE": "The settlement arrangement is incomplete."
                    }
                },
                "CREDITORS": {
                    "HEADER": "Creditors",
                    "COMPANY_NUMBER": {
                        "LABEL": "Company no."
                    },
                    "ADDRESS": {
                        "LABEL": "Address"
                    },
                    "PAYMENT_THIRD": {
                        "LABEL": "Art. 334 or payment by third parties"
                    },
                    "PAYMENTS": {
                        "TITLE": "Payment modalities",
                        "BUTTON": {
                            "LABEL": "Pay"
                        },
                        "IBAN": {
                            "LABEL": "IBAN"
                        },
                        "REMITTANCE_INFO": {
                            "LABEL": "Payment reference"
                        },
                        "PERIODIC_AMOUNT": {
                            "LABEL": "Periodic amount to pay",
                            "TOOLTIP": "Calculated based on the modalities of the repayment arrangement and the agreed amounts of the creditors."
                        },
                        "PLANNED_REPAYMENT": {
                            "LABEL": "Planned repayment"
                        }
                    },
                    "NAME": {
                        "LABEL": "Name"
                    },
                    "ADD": {
                        "PLACEHOLDER": "Select a creditor",
                        "NEW_CREDITOR": "New creditor"
                    },
                    "SPLIT_COSTS": {
                        "LABEL": "Split costs"
                    },
                    "OVERRIDE_RETAINED_AMOUNTS": {
                        "LABEL": "Override retained amounts"
                    },
                    "TO_RETAIN": {
                        "LABEL": "to retain"
                    },
                    "DATA": {
                        "TITLE": "Data"
                    },
                    "DESCRIPTION": {
                        "LABEL": "Identification"
                    },
                    "REMARKS": {
                        "LABEL": "Remarks"
                    }
                },
                "CREDITOR_PAYMENTS": {
                    "HEADER": "Repayment table",
                    "COLUMNS": {
                        "POSITION": "Nr.",
                        "NAME": "Creditor",
                        "RETAINED_AMOUNT": "Agreed",
                        "PAYMENT_THIRD_PARTIES": "Art. 334 or<br/>paym. by 3rd party",
                        "REMAINING_DEBT": "Balance",
                        "DISTRIBUTION": "Pro rata<br/>distribution"
                    },
                    "TOTAL": "Total"
                },
                "CREATE_DIVIDEND": {
                    "LABEL": "Pay a dividend",
                    "DIALOG": {
                        "TITLE": "Pay a dividend",
                        "ERROR": {
                            "IBAN": "Invalid IBAN",
                            "REMITTANCE_INFORMATION": "Invalid payment reference",
                            "REQUIRED": "Not all required fields have been completed",
                            "MAT_DATEPICKER_MIN": "The execution date cannot be in the past",
                            "MAT_DATEPICKER_PARSE": "Invalid date",
                            "MIN": "The amount should be greater than 0"
                        }
                    },
                    "BANK_ACCOUNT": {
                        "LABEL": "Bank account",
                        "PLACEHOLDER": "No accounts available"
                    },
                    "EXECUTION_DATE": {
                        "LABEL": "Date"
                    },
                    "TOTAL_AMOUNT": {
                        "LABEL": "Total amount"
                    },
                    "CREDITORS": {
                        "TITLE": "Creditors",
                        "EMPTY": "No creditors",
                        "POSITION": {
                            "LABEL": "No."
                        },
                        "COUNTERPART_NAME": {
                            "LABEL": "Creditor"
                        },
                        "COUNTERPART_REFERENCE": {
                            "LABEL": "Account number"
                        },
                        "REMITTANCE_INFORMATION": {
                            "LABEL": "Payment reference"
                        },
                        "AMOUNT": {
                            "LABEL": "Amount"
                        }
                    }
                },
                "IMPORT_CREDITORS": {
                    "LABEL": "Import from JustRestart",
                    "DIALOG": {
                        "TITLE": "Dossier: import creditors (JustRestart)",
                        "COLUMNS": {
                            "POSITION": {
                                "LABEL": "Nr."
                            },
                            "NAME": {
                                "LABEL": "Creditor"
                            },
                            "CAPITAL": {
                                "LABEL": "Capital"
                            },
                            "INTEREST": {
                                "LABEL": "Interests"
                            },
                            "NEGLIGENCE": {
                                "LABEL": "Negligence interest"
                            },
                            "PENALTY": {
                                "LABEL": "Penalty clause"
                            },
                            "COSTS": {
                                "LABEL": "Costs"
                            },
                            "TOTAL_DEBT": {
                                "LABEL": "Total debt"
                            },
                            "MAIN_SUM": {
                                "LABEL": "Main sum"
                            },
                            "INCREASES": {
                                "LABEL": "Increases"
                            },
                            "COURT_COSTS": {
                                "LABEL": "Court costs",
                                "LABEL_2": "Court costs"
                            },
                            "FIELD": {
                                "LABEL": "corresponding field"
                            },
                            "TOTAL": {
                                "LABEL": "Total"
                            },
                            "TO_RETAIN": {
                                "LABEL": "to retain"
                            },
                            "RETAINED_AMOUNT": {
                                "LABEL": "Agreed"
                            }
                        },
                        "IMPORT_DATA": {
                            "TITLE": "Data to import",
                            "FILLED_BY": {
                                "LABEL": "entered by",
                                "CREDITORS": "Creditors ({{columns}})",
                                "DEBT_MEDIATOR": "Debt mediator ({{columns}})"
                            }
                        },
                        "CHECK": {
                            "TITLE": "Check"
                        },
                        "ERROR": {
                            "NON_FINAL": " ",
                            "MIN": "Only positive amounts are allowed"
                        },
                        "VALIDATION": {
                            "TITLE": "Validation"
                        }
                    }
                },
                "MANUAL_CREDITORS": {
                    "LABEL": "Input manually"
                }
            },
            "CLIENT_NOTIFICATIONS": {
                "RESPOND_TO_DOCUMENT": {
                    "TITLE": "Payment request",
                    "NOTIFICATION": "Request to pay",
                    "RESPONSE": "Response",
                    "MESSAGE": {
                        "TITLE": "Message to the client (optional)",
                        "PLACEHOLDER": "Type here"
                    }
                }
            },
            "CLIENT_DOSSIER": {
                "EDIT": {
                    "DIALOG": {
                        "TITLE": "Dossier: {{ type }}",
                        "ERROR": {
                            "END_BEFORE_START": "End date is before start date",
                            "SUM": "The total debt is not equal to the sum of the partial debts",
                            "MIN": "The value is lower than the minimum",
                            "MAX": "The value is higher than the maximum",
                            "REQUIRED": "Not all required fields have been completed",
                            "IBAN": "Invalid IBAN",
                            "TOTAL_DEBT": "The total debt of the dossier does not equal the sum of the total debts per creditor.",
                            "MAIN_SUM": "The main sum of the dossier does not equal the sum of the main sums per creditor.",
                            "INTEREST": "The interest of the dossier does not equal the sum of the total debts per creditor.",
                            "COSTS": "The costs of the dossier don't equal the sum of the costs per creditor.",
                            "COURT_COSTS": "The court costs of the dossier don't equal the sum of the court costs per creditor.",
                            "INCREASES": "The increases of the dossier don't equal the sum of the increases per creditor.",
                            "RETAINED_AMOUNT": "The agreed amount of the dossier does not equal the sum of the agreed amounts per creditor.",
                            "CREDITORS_UNIQUE": "Not all creditors are unique (same combination of name, IBAN and payment reference).",
                            "REMITTANCE_INFORMATION": "Invalid payment reference",
                            "MAT_DATEPICKER_PARSE": "Invalid date"
                        }
                    }
                }
            },
            "EDIT_DOSSIER": {
                "DIALOG": {
                    "ADD_CREDITOR": "Add creditor"
                }
            },
            "CLIENT_DOCUMENTS": {
                "CREATE_RB_DOCUMENT": {
                    "DIALOG": {
                        "TITLE": "Generate a new document",
                        "ERROR": {
                            "ACCOUNTS": "No account selected",
                            "REQUIRED": "Not all required fields have been completed or selected",
                            "MAT_DATEPICKER_MAX": "The period is not in the allowed range",
                            "MAT_DATEPICKER_MIN": "The period is not in the allowed range",
                            "END_BEFORE_START": "End date is before start date"
                        }
                    },
                    "TYPE": {
                        "TITLE": "Document type",
                        "DISABLED": "Some types of documents cannot be generated. The client is not linked to the necessary bank accounts.",
                        "UNAVAILABLE": "It is not possible to generate a document. The client is not linked to the necessary bank accounts."
                    },
                    "ACCOUNTS": {
                        "TITLE": "Bank accounts",
                        "NONE": "No selection of accounts is required for this document type.",
                        "OFFICE": "the office",
                        "CLIENT": "the client",
                        "MANAGED_BY": "Managed by",
                        "BULK": "Separate documents are generated for each selected account.",
                        "MULTIPLE": "1 document is generated containing all selected accounts."
                    },
                    "PERIOD": {
                        "TITLE": "Period",
                        "CUSTOM": "Free",
                        "MONTHLY": "Month",
                        "QUARTERLY": "Quarter",
                        "YEARLY": "Year",
                        "NONE": "No period needs to be set for this document type.",
                        "FROM": "From",
                        "UNTIL": "Until",
                        "COMPARE": "Comparison with previous period:"
                    },
                    "UNAVAILABLE": "Unavailable",
                    "HISTORY": {
                        "INCOMPLETE": "The history for one or more accounts is incomplete for the selected period"
                    }
                }
            },
            "BUDGET": {
                "CALCULATION_PERIOD": {
                    "LABEL": "Reference period for actual amounts",
                    "YEAR_1": "1 year",
                    "MONTH_1": "1 month",
                    "MONTH_3": "3 months",
                    "MONTH_6": "6 months"
                },
                "EDIT": {
                    "LABEL": "Edit",
                    "DIALOG": {
                        "TITLE": "Budget"
                    },
                    "TABS": {
                        "INCOME": "Income",
                        "EXPENSES": "Expenses",
                        "REMARKS": "Remarks"
                    },
                    "AUTOMATIC_ALLOWANCE": "Calculate living allowance automatically",
                    "ACTUAL_PERIOD": "Reference period for actual amounts",
                    "RECEIVED_BY_CLIENT": "Received by client",
                    "PAID_BY_CLIENT": "Paid by client",
                    "DETAILED": "Detailed budget",
                    "PERIOD": "Period",
                    "USE_ACTUAL": "Use actual amount",
                    "REMARK": {
                        "PLACEHOLDER": "Remark"
                    },
                    "REMARKS": {
                        "PLACEHOLDER": "Remarks"
                    }
                },
                "REMARKS": {
                    "HEADER": "Remarks",
                    "COPY": "Copy"
                },
                "MANAGED_BY_CLIENT": {
                    "HEADER": "Client’s budget plan"
                },
                "TABLE": {
                    "CATEGORY": "Category",
                    "PLAN": "Plan",
                    "ACTUAL": "Actual",
                    "INCOME": "Income",
                    "EXPENSES": "Expenses",
                    "PROVISION": "Provision for unforeseen costs & extras",
                    "TOTAL": "Total"
                },
                "PERIODICITY": {
                    "MONTHLY": {
                        "SHORT": "m"
                    },
                    "YEARLY": {
                        "SHORT": "y"
                    }
                },
                "MANAGED_BY_OFFICE": {
                    "DEBT_MEDIATION": {
                        "HEADER": "Debt mediator's budget plan"
                    },
                    "FINANCIAL_MANAGEMENT": {
                        "HEADER": "Adminstrator's budget plan"
                    },
                    "BUDGET_GUIDANCE": {
                        "HEADER": "Budget manager’s budget plan"
                    },
                    "RENT": {
                        "HEADER": "Landlord’s budget plan"
                    },
                    "SOCIAL_RENT": {
                        "HEADER": "Landlord’s budget plan"
                    },
                    "PCSW": {
                        "HEADER": "PCSW budget plan"
                    }
                },
                "UNPLANNED": {
                    "HEADER": "Not in budget plan"
                },
                "UNCATEGORIZED": {
                    "LABEL": "Without category"
                },
                "CLIENT_ONLY": {
                    "EDIT_HEADER": "Total for budget plan",
                    "VIEW_HEADER": "Budget plan"
                }
            }
        },
        "CONTACTS": {
            "HEADER": {
                "LABEL": "Contacts"
            }
        },
        "DASHBOARD": {
            "HEADER": {
                "LABEL": "Dashboard"
            }
        },
        "MESSAGES": {
            "HEADER": {
                "LABEL": "Messages"
            }
        },
        "NOTIFICATIONS": {
            "HEADER": {
                "LABEL": "Notifications"
            },
            "FILTER": {
                "TYPE": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "All notifications"
                        },
                        "NOT_ENOUGH_FUNDS": {
                            "LABEL": "Not enough funds"
                        },
                        "BALANCE_EXCEEDED_THRESHOLD": {
                            "LABEL": "Balance above"
                        },
                        "INCOME_DETECTED": {
                            "LABEL": "Income detected"
                        },
                        "INSUFFICIENT_BALANCE_EXPECTED": {
                            "LABEL": "Insufficient funds expected"
                        },
                        "UNEXPECTED_INCOME_LOSS": {
                            "LABEL": "Unexpected loss of income"
                        },
                        "RECURRING_EXPENSE_MISSING": {
                            "LABEL": "Expected payment is missing"
                        },
                        "NEW_RECURRING_EXPENSES": {
                            "LABEL": "New debt detected"
                        },
                        "DOCUMENT_PAYMENT_REQUEST": {
                            "LABEL": "Request to pay"
                        },
                        "YEARLY_REPORT_DUE": {
                            "LABEL": "Yearly report is due"
                        },
                        "FINAL_REPORT_DUE": {
                            "LABEL": "Final report is due"
                        }
                    }
                }
            },
            "TABLE": {
                "COLUMN": {
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    }
                }
            },
            "PROCESS_NOTIFICATIONS": {
                "DIALOG": {
                    "TITLE": "Close notifications"
                },
                "ALL": "Are you sure you want to close all open notifications voor all clients?",
                "TYPE": "Are you sure you want to close all open notifications of this type for all clients?",
                "WARNING": "This action can only be undone by reopening the notifications one by one."
            }
        },
        "OFFICE": {
            "HEADER": {
                "LABEL": "My office"
            }
        },
        "PAYMENTS": {
            "HEADER": {
                "LABEL": "Payments"
            },
            "FILTER": {
                "STATUS": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "All payments"
                        },
                        "NOT_SUBMITTED": {
                            "LABEL": "In queue"
                        },
                        "SUBMITTED": {
                            "LABEL": "Submitted"
                        },
                        "NOT_PROCESSED": {
                            "LABEL": "Being validated"
                        },
                        "PROCESSED_WARNING": {
                            "LABEL": "Validation warning"
                        },
                        "PROCESSED_ERROR": {
                            "LABEL": "Validation error"
                        },
                        "PROCESSED_OK": {
                            "LABEL": "Validated"
                        },
                        "PAID": {
                            "LABEL": "Paid"
                        }
                    }
                }
            },
            "BUTTON": {
                "SUBMIT": {
                    "LABEL": "Submit queue"
                },
                "ADD": {
                    "LABEL": "Add payment"
                },
                "SUBMIT_SELECTION": {
                    "LABEL": "Submit selection"
                },
                "REQUEUE": {
                    "LABEL": "Requeue"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "AMOUNT": {
                        "HEADER": {
                            "LABEL": "Amount"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    },
                    "ACCOUNT": {
                        "HEADER": {
                            "LABEL": "Account"
                        }
                    },
                    "COUNTERPART": {
                        "HEADER": {
                            "LABEL": "Beneficiary"
                        }
                    },
                    "REMITTANCE_INFO": {
                        "HEADER": {
                            "LABEL": "Payment reference"
                        }
                    },
                    "DATE": {
                        "HEADER": {
                            "LABEL": "Date"
                        }
                    }
                },
                "EMPTY": "No payments found"
            },
            "NOT_SUPPORTED": "Account does not support payments (anymore)",
            "PREPARE": {
                "SELECTED": "Selected: {{count}} of {{total}}",
                "NOT_VISIBLE": "{{count}} not visible"
            },
            "DELETE": "Delete",
            "EDIT": "Edit",
            "DELETE_PAYMENT": {
                "QUESTION": "Are you sure you want to delete this payment?",
                "DIALOG": {
                    "TITLE": "Delete payment"
                }
            },
            "REPEAT": "Repeat",
            "DOWNLOAD_DOCUMENT": "Download document",
            "REQUEST": {
                "KNOWN": "Submitted",
                "UNKNOWN": "Queue",
                "STATUS": {
                    "PROCESSING": {
                        "LABEL": "Being validated by Isabel 6"
                    },
                    "WARNING": {
                        "LABEL": "Warning in Isabel 6"
                    },
                    "ERROR": {
                        "LABEL": "Error message in Isabel 6"
                    },
                    "VALIDATED": {
                        "LABEL": "Validated by Isabel 6"
                    },
                    "PARTIALLY_PAID": {
                        "LABEL": "Partially executed"
                    },
                    "PAID": {
                        "LABEL": "Executed"
                    }
                },
                "SUBMITTING": "Being submitted"
            },
            "STATUS": {
                "NOT_SUBMITTED": {
                    "LABEL": "Payment in queue"
                },
                "PROCESSED_WARNING": {
                    "LABEL": "Warning during payment validation by Isabel 6"
                },
                "PROCESSED_ERROR": {
                    "LABEL": "Error message during payment validation by Isabel 6"
                },
                "PROCESSED_OK": {
                    "LABEL": "Payment validated by Isabel 6"
                },
                "PAID": {
                    "LABEL": "Payment executed"
                },
                "NOT_PROCESSED": {
                    "LABEL": "Being validated by Isabel 6"
                },
                "SUBMITTED": {
                    "LABEL": "Submitted to Isabel 6"
                },
                "SUBMITTING": {
                    "LABEL": "Being submitted"
                }
            },
            "FILTERS": {
                "STATUS": {
                    "LABEL": "Status"
                },
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Search"
                },
                "CLIENT": {
                    "LABEL": "Client"
                },
                "COUNTERPART": {
                    "LABEL": "Beneficiary"
                },
                "DATE": {
                    "TITLE": "expected execution date"
                }
            },
            "SUBMIT_PAYMENTS": {
                "DIALOG": {
                    "TITLE": "Submit payments to Isabel 6",
                    "OVERVIEW": {
                        "PAYMENTS": "payments",
                        "PAYMENT": "payment"
                    },
                    "POSSIBLE_DUPLICATE_PAYMENTS": {
                        "TITLE": "Potential duplicates",
                        "DESCRIPTION": "The payments below are already duplicated in the queue or were submitted recently.",
                        "CLIENT": "Client",
                        "ACCOUNT": "Account",
                        "COUNTERPART": "Beneficiary",
                        "REMITTANCE_INFORMATION": "Remittance information",
                        "QUEUED": "x in queue",
                        "SUBMITTED_AT": "Submitted on",
                        "EXECUTED_AT": "Executed on",
                        "EMPTY": "No similar payments found"
                    },
                    "INSUFFICIENT_BALANCES": {
                        "TITLE": "Insufficient balance",
                        "DESCRIPTION": "The balance of these accounts is insufficient to execute all payments.",
                        "CLIENT": "Client",
                        "ACCOUNT": "Account",
                        "IBAN": "IBAN",
                        "BALANCE": "Balance",
                        "COUNTERPART": "Beneficiary",
                        "REMITTANCE_INFORMATION": "Remittance information",
                        "TOTAL": "TOTAL",
                        "EMPTY": "The balance of all accounts is sufficient for the payments."
                    },
                    "CONFIRM": {
                        "LABEL": "Submit payments"
                    }
                }
            }
        },
        "PROFILE": {
            "HEADER": {
                "LABEL": "My profile"
            }
        },
        "BUTTON": {
            "CONFIRM": {
                "LABEL": "Confirm"
            },
            "CANCEL": {
                "LABEL": "Cancel"
            },
            "EXPORT": {
                "LABEL": "Export"
            },
            "ADD": {
                "LABEL": "Add"
            },
            "DELETE": {
                "LABEL": "Delete"
            },
            "EDIT": {
                "LABEL": "Edit"
            },
            "CLOSE": {
                "LABEL": "Close"
            },
            "NEXT": {
                "LABEL": "Next"
            },
            "PREVIOUS": {
                "LABEL": "Back"
            },
            "SKIP": {
                "LABEL": "Skip"
            },
            "PROCESS_NOTIFICATIONS": {
                "LABEL": "Close notifications"
            },
            "OK": {
                "LABEL": "Okay"
            }
        },
        "BANK_ACCOUNT": {
            "AVAILABLE_BALANCE": {
                "LABEL": "Available"
            },
            "SHARE_SETTINGS": {
                "OFFICE": "Visible to client:",
                "CLIENT": "Shared with you:",
                "BALANCE": "Balance",
                "TRANSACTIONS": "Transactions",
                "INCOMING_TRANSACTIONS": "Incoming transactions",
                "OUTGOING_TRANSACTIONS": "Outgoing transactions",
                "SHARED_BY": "Shared by",
                "SHARED_BY_UNKNOWN": "Former user"
            },
            "NO_LINKED_CLIENT": "Link this account to a new or existing<br/>client to view the balance and transactions.",
            "LATEST_SYNC": "Synchronized",
            "BUTTON": {
                "LINK_CLIENT": {
                    "LABEL": "Link client"
                },
                "CREATE_CLIENT": {
                    "LABEL": "Create client"
                },
                "AUTHORIZE": {
                    "LABEL": "Renew authorization"
                },
                "PAYMENT": {
                    "LABEL": "New payment"
                },
                "IMPORT": {
                    "LABEL": "Import history"
                },
                "SELECT": {
                    "LABEL": "Select"
                }
            },
            "WARNING": {
                "AUTH_INVALID": "The authorization of this account is no longer valid.<br/>To resume synchronization, the authorization needs to be renewed.",
                "EXPIRING": "The authorization for this account expires on {{ date }}.<br>To avoid an interruption of the synchronization, the authorization needs to be renewed in time.",
                "TECHNICAL_FAILURE": "Technical failure<br>Due to a technical issue at {{ bank }}, synchronization is temporarily not possible.",
                "ARCHIVED": "This account was archived on {{ date }}",
                "MOVED_TO_ISABEL_ACTIVE": "The link with {{ bank }} has moved to Isabel 6.<br>Synchronization will end on {{ date }}, unless this account can be fetched from Isabel Connect by then.",
                "MOVED_TO_ISABEL_INACTIVE": "The link with {{ bank }} has moved to Isabel 6.<br>Synchronization will resume as soon as this account can be fetched from Isabel Connect.",
                "NOT_FOUND_IN_ISABEL": "This account is no longer available through Isabel Connect.<br>Synchronization will resume as soon as this account can be fetched from Isabel Connect again.",
                "BLOCKED": "This account was added by a user of the client app who has since been blocked.<br/>Synchronization is no longer performed."
            },
            "TABLE": {
                "COLUMN": {
                    "CATEGORY": {
                        "HEADER": {
                            "LABEL": "Category"
                        },
                        "CREDITOR": "Creditor",
                        "INTRADAY": {
                            "LABEL": "Intraday transaction",
                            "INFO": "Intraday transactions cannot be changed because they are not final yet"
                        }
                    },
                    "COUNTERPART": {
                        "HEADER": {
                            "LABEL": "Counterparty"
                        }
                    },
                    "DETAILS": {
                        "HEADER": {
                            "LABEL": "Details"
                        },
                        "REMITTANCE_INFO": "Payment reference",
                        "COUNTERPART": {
                            "FROM": "From",
                            "TO": "To"
                        },
                        "VALUE_DATE": "Value date",
                        "INTERNAL_NOTE": "Internal note"
                    },
                    "AMOUNT": {
                        "HEADER": {
                            "LABEL": "Amount"
                        }
                    },
                    "TAGS": {
                        "HEADER": {
                            "LABEL": "Tags"
                        }
                    }
                },
                "EMPTY": "No transactions found",
                "ACTIONS": {
                    "REPEAT": "Pay again",
                    "DOWNLOAD": "Download document",
                    "UPLOAD_DOCUMENT": "Upload document"
                },
                "NOTIFICATIONS_ONLY": "Only notifications are shared for this account."
            },
            "FILTERS": {
                "CATEGORY": {
                    "TITLE": "Category",
                    "UNCATEGORIZED": "No category",
                    "MULTIPLE": "Multiple categories"
                },
                "DATE": {
                    "TITLE": "Execution date"
                },
                "COUNTERPART": {
                    "VALUE": {
                        "NAME": "Name contains \"{{counterpart}}\"",
                        "REFERENCE": "IBAN contains \"{{counterpart}}\""
                    },
                    "TITLE": "Counterparty",
                    "NAME": "Name contains",
                    "REFERENCE": "IBAN contains"
                },
                "REMITTANCE_INFO": {
                    "TITLE": "Payment reference",
                    "CONTAINS": "Payment reference contains",
                    "VALUE": "Payment reference contains \"{{remittanceInfo}}\""
                },
                "TYPE": {
                    "TITLE": "Type",
                    "CONTAINS": "Type contains",
                    "VALUE": "Type contains \"{{description}}\""
                },
                "AMOUNT": {
                    "TITLE": "Amount",
                    "MIN": "Minimum",
                    "MAX": "Maximum",
                    "VALUE": {
                        "MIN": "≥ {{amountMin}}",
                        "BETWEEN": "{{amountMin}} – {{amountMax}}",
                        "MAX": "≤ {{amountMax}}"
                    },
                    "ALL": "Incoming & outgoing",
                    "DEBIT": "Outgoing",
                    "CREDIT": "Incoming"
                },
                "TAGS": {
                    "MULTIPLE": "Multiple tags",
                    "TITLE": "Tags"
                },
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Search"
                }
            },
            "EDIT_CLIENT_SETTINGS": {
                "TITLE": "Client settings",
                "LINKED_CLIENT": {
                    "HEADER": "Linked client"
                },
                "TYPE": {
                    "HEADER": "Account type"
                },
                "SELECT_CLIENT": "Select client",
                "NO_CLIENT": "None"
            },
            "EDIT_TRANSACTION_CATEGORY": {
                "TITLE": "Category",
                "APPLY_TO": "Apply to",
                "TRANSACTION": {
                    "TO": "To",
                    "REMITTANCE_INFO": "Payment reference"
                },
                "CREDITOR": "Creditor",
                "TYPES": {
                    "INCOMING": {
                        "TRANSACTION": "Only this transaction",
                        "ACCOUNT": "All income of <u>this account</u> that comply with",
                        "CLIENT": "All income of <u>this client</u> that comply with",
                        "ALL_CLIENTS": "All income of <u>all clients</u> that comply with"
                    },
                    "OUTGOING": {
                        "TRANSACTION": "Only this transaction",
                        "ACCOUNT": "All expenses of <u>this account</u> that comply with",
                        "CLIENT": "All expenses of <u>this client</u> that comply with",
                        "ALL_CLIENTS": "All expenses of <u>all clients</u> that comply with"
                    }
                },
                "FILTERS": {
                    "COUNTERPART_REFERENCE": "Counterparty reference is",
                    "COUNTERPART_NAME": "Counterparty contains",
                    "REMITTANCE_INFO": "Payment reference contains",
                    "DATE_FROM": "Earliest date",
                    "DATE_TO": "Last date",
                    "AMOUNT_MIN": "Minimum amount",
                    "AMOUNT_MAX": "Maximum amount",
                    "DESCRIPTION": "Type contains",
                    "CATEGORY": "Category is"
                },
                "ADD_CATEGORY": "New category",
                "MAIN_CATEGORY": "Main category",
                "NEW_SUB_CATEGORY": {
                    "TITLE": "New sub category",
                    "ERROR": {
                        "REQUIRED": "Required",
                        "DUPLICATE": "already added"
                    }
                },
                "CATEGORY": {
                    "ERROR": {
                        "REQUIRED": "Not all required fields have been completed",
                        "DUPLICATE": "Category has already been added",
                        "MIN": "Only positive numbers allowed",
                        "FILTER_REQUIRED": "Select at least one filter"
                    },
                    "SELECT": "Select a category"
                },
                "ADD_CATEGORY_NOTICE": "Custom categories are available for all clients."
            },
            "EDIT_TRANSACTION_DETAILS": {
                "TRANSACTION": {
                    "TITLE": "Transaction"
                }
            },
            "SET_ARCHIVED_STATUS": {
                "DIALOG": {
                    "STATUS": {
                        "TITLE": "Status",
                        "ARCHIVED": "Archived on {{ date }}",
                        "ACTIVE": "Active"
                    },
                    "TITLE": "Archive",
                    "ACTION": {
                        "TITLE": "Action",
                        "ARCHIVED": "Restore",
                        "ACTIVE": "Archive"
                    },
                    "INFO": {
                        "ARCHIVED": "Restoring a bank account involves:\n<ul>\n<li>The account is displayed again in the list of active accounts.</li>\n<li>The account can again be linked to a (different) client.</li>\n<li>It is again possible to customize the category and tags of an transaction.</li>\n<li>If the account is available through Isabel Connect, synchronization will automatically resume.</li>\n<li>If the account was added directly through the bank, the authorization will have to be renewed.</li>\n<li><b>NOTE: If the account has been archived for a long time, it's possible that the history cannot be fully completed!</b></li>\n</ul>",
                        "ACTIVE": "Archiving a bank account involves:\n<ul>\n<li>The account is no longer shown in the list of active accounts.</li>\n<li>The account can no longer be linked to a client.</li>\n<li>If the account is already linked to a client, the account remains visible with that client.</li>\n<li>The category and tags of a transaction can no longer be modified.</li>\n<li>Transactions are no longer synchronized and the balance is no longer available.</li>\n</ul>",
                        "NOT_RESTORABLE": "This account cannot be restored:\n<ul>\n<li>The account is linked to an archived client.</li>\n<li>To restore the account, first restore the linked client.</li>\n</ul>"
                    }
                }
            },
            "EDIT_TRANSACTION_TAGS": {
                "TITLE": "Tags",
                "ADD_TAG_NOTICE": "Tags are available for each client separately.",
                "NEW_TAG": "New tag",
                "ERROR": {
                    "DUPLICATE": "already added",
                    "REQUIRED": "Not all required fields have been completed",
                    "MIN": "Only positive numbers allowed",
                    "FILTER_REQUIRED": "Select at least one filter"
                }
            },
            "SELECTED": {
                "SINGULAR": "1 transaction selected",
                "PLURAL": "{{count}} transactions selected",
                "SUM": {
                    "BALANCE": "total",
                    "INCOME": "incoming",
                    "EXPENSES": "outgoing"
                }
            }
        },
        "FILTER": {
            "TITLE": "Filter by",
            "SET": "Set"
        },
        "FILTERS": {
            "DATE": {
                "TITLE_SHORT": "Date",
                "FROM": "From",
                "TO": "Through",
                "VALUE": {
                    "FROM": "From {{dateFrom}}",
                    "TO": "Through {{dateTo}}",
                    "FROM_TO": "{{dateFrom}} – {{dateTo}}"
                }
            }
        },
        "TABLE": {
            "COLLAPSE_ALL": "Collapse all",
            "EXPAND_ALL": "Expand all"
        },
        "DOCUMENTS": {
            "TABLE": {
                "COLUMN": {
                    "DOCUMENT": {
                        "HEADER": {
                            "LABEL": "Document"
                        }
                    },
                    "DATE": {
                        "HEADER": {
                            "LABEL": "Date"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    }
                },
                "EMPTY": "No documents found"
            },
            "TYPE": {
                "DOCUMENT": "Document",
                "IMAGE": "Image",
                "FINANCIAL_REPORT": "Financial report",
                "YEARLY_DEBT_REPORT": "Yearly report CSR/RCD",
                "FINAL_DEBT_REPORT": "Final report CSR/RCD",
                "YEARLY_REPORT_XLSX_GUARDIANSHIP": "Guardianship reporting",
                "YEARLY_OVERSIGHT_REPORT": "Account statement",
                "ARCHIVE": "Archive",
                "HONORARIUM_GUARDIANSHIP": "Taxation",
                "ACTIVE_DOSSIERS_DEBT_REPORT": "Overview active debt mediation dossiers",
                "EMAIL": "Email",
                "YEARLY_OVERSIGHT_REPORT_WITH_DOCUMENTS": "Account statement with attachments",
                "HONORARIUM_DEBT_MEDIATION": "Debt mediation fees"
            },
            "GENERATED_BY": "Generated by",
            "ADDED_BY": "Uploaded by",
            "SYSTEM_USER": "ROOV",
            "SHARED_WITH_CLIENT": "Shared with the client",
            "HIDDEN": "Hidden",
            "FILTER": {
                "SHOW_HIDDEN": {
                    "LABEL": "Show hidden"
                }
            },
            "FILTERS": {
                "TYPE": {
                    "MULTIPLE": "Multiple types",
                    "LABEL": "Type"
                },
                "OWNER": {
                    "LABEL": "Owner",
                    "MULTIPLE": "Multiple owners"
                },
                "CLIENT": {
                    "LABEL": "Client"
                }
            },
            "BUTTON": {
                "GENERATE": {
                    "LABEL": "Generate"
                },
                "UPLOAD": {
                    "LABEL": "Upload"
                },
                "PROCESS_ALL": {
                    "LABEL": "Process all"
                },
                "SELECT": {
                    "LABEL": "Select"
                },
                "SELECT_ALL": {
                    "LABEL": "Select all"
                },
                "PAY": {
                    "LABEL": "Pay"
                },
                "ASSIGN": {
                    "LABEL": "Assign"
                },
                "DELETE": {
                    "LABEL": "Delete"
                },
                "MOVE": {
                    "LABEL": "Reassign"
                },
                "EMAIL": {
                    "LABEL": "Add via email"
                }
            },
            "DROP": "Drop your documents here",
            "EXTENSIONS": "Accepted file types",
            "UPLOAD_LIMITS": "Maximum 20MB per file and 200MB in total.",
            "RENAME": "Rename",
            "DELETE": "Delete",
            "HIDE": "Hide",
            "MAKE_VISIBLE": "Make visible",
            "SHARE": "Share",
            "STOP_SHARING": "Stop sharing",
            "CREATE_PAYMENT": "Pay",
            "EDIT_PAYMENT": "Edit payment",
            "REPEAT_PAYMENT": "Pay again",
            "HEADER": {
                "LABEL": "Documents"
            },
            "ACTIVE_DEBT_DOSSIERS_REPORT": {
                "CREATE_SOON": "Generate here from July 1 the overview with status on 30/06 of active debt mediation dossiers.",
                "CREATE_NOW": "Generate now the overview with status on 30/06 of active debt mediation dossiers.",
                "BUTTON": {
                    "LABEL": "Generate"
                },
                "LABOUR_COURT": {
                    "PLACEHOLDER": "Select a labour court"
                }
            },
            "UNPROCESSED": "To process",
            "PROCESSED": "Processed",
            "ASSIGN": "Assign",
            "SELECTED": {
                "SINGULAR": "1 document selected",
                "PLURAL": "{{count}} documents selected"
            },
            "MOVE": "Reassign",
            "ADDED_BY_EMAIL": "Added via email from",
            "ADDED_BY_EMAIL_OWNER": "Added via email by",
            "EMAIL": {
                "DIALOG": {
                    "TITLE": "Add documents via email",
                    "FIRST_LINE": "Add documents by emailing them as attachments to:",
                    "ADDITIONAL_INFO": "Supported documents sent to this address as attachments will be added to the documents to be processed.",
                    "BUTTON": {
                        "COPY": {
                            "LABEL": "Copy address"
                        }
                    }
                }
            },
            "DOWNLOAD": "Download",
            "SHARED_BY_CLIENT": "Shared from client app"
        },
        "ADD_PAYMENT_DIALOG": {
            "TITLE": "New payment",
            "FROM": {
                "HEADER": "From",
                "CLIENT": {
                    "TITLE": "Client",
                    "NO_CLIENT": "Select a client"
                },
                "ACCOUNT": {
                    "TITLE": "Account",
                    "NO_ACCOUNT": "Select an account"
                }
            },
            "TO": {
                "HEADER": "To",
                "BENEFICIARY": {
                    "TITLE": "Beneficiary",
                    "NO_BENEFICIARY": "Select a beneficiary",
                    "NO_EDIT_CREDITOR": "Creditor linked to the client. Cannot be edited here.",
                    "NO_EDIT_BANK_ACCOUNT": "Bank account linked to the client. Cannot be edited here.",
                    "NAME": "Name",
                    "IBAN": "IBAN",
                    "SINGLE_USE": "One time use",
                    "CLIENT": "Save for client",
                    "GLOBAL": "Save globally",
                    "ADD_BENEFICIARY": "New beneficiary"
                }
            },
            "DATA": {
                "HEADER": "Coordinates",
                "AMOUNT": {
                    "TITLE": "Amount"
                },
                "REMITTANCE_INFO": {
                    "TITLE": "Payment reference"
                },
                "EXECUTION_DATE": {
                    "TITLE": "Execution date"
                }
            },
            "ERROR": {
                "REMITTANCE_INFORMATION": "Invalid payment reference",
                "REQUIRED": "Not all required fields have been completed",
                "MAT_DATEPICKER_MIN": "The execution date cannot be in the past",
                "MAT_DATEPICKER_PARSE": "Invalid date",
                "MIN": "The amount should be greater than 0",
                "EDITING": "Beneficiary must first be saved",
                "IBAN": "Invalid IBAN",
                "UNIQUE": "An account with this IBAN already exists",
                "BENEFICIARY_NAME": "Invalid name",
                "SAME_IBAN": "Le numéro de compte du bénéficiaire est le même que celui du paiement",
                "MAT_DATEPICKER_MAX": "The execution date cannot be more than one year in the future",
                "DOCUMENT_NAME_EDITING": "Name needs to be saved first"
            },
            "ANOTHER_PAYMENT": "Add another payment",
            "WARNING": {
                "DUPLICATE_PAYMENT_EXECUTED": "A similar payment was already made on {{date}}",
                "DUPLICATE_PAYMENT_SUBMITTED": "A similar payment was already submitted on {{date}}",
                "DUPLICATE_PAYMENT_QUEUED": "A similar payment is already in the queue"
            },
            "ANOTHER_PAYMENT_DESCRIPTION": "Selected fields are copied over.",
            "INTERNAL_NOTE": {
                "TITLE": "Internal note",
                "DESCRIPTION": "Only available in ROOV Business.",
                "PLACEHOLDER": "Internal note"
            }
        },
        "DOCUMENT": {
            "RENAME_DOCUMENT": {
                "DIALOG": {
                    "TITLE": "Rename document",
                    "ERROR": {
                        "REQUIRED": "Enter a name"
                    }
                },
                "NAME": {
                    "LABEL": "Name",
                    "PLACEHOLDER": "Name without file extension"
                }
            },
            "DELETE_DOCUMENT": {
                "DIALOG": {
                    "TITLE_SINGLE": "Delete document",
                    "QUESTION_SINGLE": "Are you sure you want to delete this document?",
                    "INFO_SINGLE": "If the document is shared, it will also be deleted for the client. This action cannot be undone.",
                    "TITLE_MULTI": "Delete documents",
                    "QUESTION_MULTI": "Are you sure you want to delete these documents?",
                    "INFO_MULTI": "If a document is shared, it will also be deleted for the client. This action cannot be undone."
                }
            },
            "ASSIGN_DOCUMENT": {
                "DIALOG": {
                    "TITLE_SINGLE": "Assign document to a client",
                    "ASSIGN_TO": "Assign to",
                    "ERROR": {
                        "REQUIRED": "Select a client",
                        "DOCUMENT_NAME_EDITING": "Name needs to be saved first"
                    },
                    "TITLE_MULTI": "Assign documents to a client",
                    "SELECTED_DOCUMENTS": "Selected documents"
                }
            },
            "VIEW_DOCUMENT": {
                "DIALOG": {
                    "TITLE": "Document"
                }
            }
        },
        "CLIENT": {
            "CLIENT_APP": {
                "STATUS": {
                    "NOT_SENT": "Send an invitation by email or provide the personal code.",
                    "SENT": "An invitation was sent by email on {{date}}.",
                    "CLAIMED": "The link to the mobile account was made on {{date}}.",
                    "REVOKED": "The link to the mobile account was disconnected on {{date}}."
                },
                "CODE": {
                    "TITLE": "Personal code",
                    "MESSAGE": "Entering this code in the ROOV mobile app will link the mobile account to this client."
                },
                "INFO": {
                    "TITLE": "Through ROOV's mobile app, information can be exchanged between you and the client.",
                    "FEATURE_1": "You will have access to the account(s) added by the client. For each account, the client chooses whether to share the balance and/or transactions. When (potential) problems arise, you will receive a notification.",
                    "FEATURE_2": "The client gets access to the account(s) you manage for them. You can configure what information is shared for each account.",
                    "FEATURE_3": "You can share documents with the client and vice versa.",
                    "FEATURE_4": "The client can request payment of an invoice from an account managed by you.",
                    "ACCESS": {
                        "TITLE": "You decide whether to grant access to this dossier.",
                        "DESCRIPTION": "Invite a user by email address or mobile number. Afterwards, you can block the user to revoke access and optionally invite another user."
                    },
                    "CLIENT_ACCOUNTS": {
                        "TITLE": "You can access the account(s) added by the user.",
                        "DESCRIPTION": "For each account, the user chooses which information is shared and whether you may receive notifications when (potential) problems arise."
                    },
                    "OFFICE_ACCOUNTS": {
                        "TITLE": "The user can access the account(s) you manage for this dossier.",
                        "DESCRIPTION": "You can configure which information is shared for each account."
                    },
                    "DOCUMENTS": {
                        "TITLE": "You can share documents with the user and vice versa.",
                        "OWN_DESCRIPTION": "You can recognize documents you share by this icon:",
                        "CLIENT_DESCRIPTION": "Documents shared with you can be recognized by this icon:"
                    },
                    "PAYMENT_REQUESTS": {
                        "TITLE": "The user can submit a request to pay an invoice from an account managed by you.",
                        "DOCUMENT_DESCRIPTION": "The invoice appears as a shared document in the list.",
                        "NOTIFICATION_DESCRIPTION": "You also receive a notification from which you can accept or reject the request and create the payment."
                    }
                },
                "ARCHIVED": "Linking to a mobile account is only possible for active clients.",
                "SEND_INVITATION": {
                    "EMAIL": "Client email",
                    "SEND_COPY": "deliver a copy to myself",
                    "SEND": "Send invitation",
                    "SEND_AGAIN": "Resend invitation"
                },
                "MOBILE_USER": {
                    "ACTIVE_USER": "Active user",
                    "LOGIN_METHOD": "Login method",
                    "EMAIL": "E-mail",
                    "PHONE": "Mobile number",
                    "INVITE": {
                        "LABEL": "Invite user",
                        "LOADING": "Loading users",
                        "ERROR": "Users could not be loaded",
                        "ACTIVE_USER": "There is already an active user"
                    }
                },
                "MOBILE_USER_INVITATION_DIALOG": {
                    "TITLE": "Invite user to the mobile app",
                    "PERSONAL_INFO": "Personal details",
                    "LOGIN_INFO": "Login details",
                    "FIRST_NAME": "First name",
                    "LAST_NAME": "Last name",
                    "EMAIL": "Email address",
                    "PHONE": "Mobile number",
                    "NO_EMAIL_ACCESS": "This user does not have access to email.",
                    "NO_EMAIL_ACCESS_INFO": "If the user does not have access to email on their smartphone, they can log in via SMS.",
                    "ERROR": {
                        "REQUIRED": "Check required fields",
                        "EMAIL": "Invalid email address",
                        "PATTERN": "Invalid mobile number",
                        "DUPLICATE": "User already exists"
                    },
                    "COUNTRY_CODE": "Country code",
                    "PHONE_NUMBER": "Mobile number",
                    "COUNTRY": {
                        "BELGIUM": "Belgium",
                        "NETHERLANDS": "Netherlands",
                        "FRANCE": "France",
                        "GERMANY": "Germany",
                        "LUXEMBOURG": "Luxembourg"
                    }
                }
            }
        },
        "SETTINGS": {
            "HEADER": {
                "LABEL": "Settings"
            },
            "TAB": {
                "ACCOUNT": {
                    "LABEL": "My account",
                    "INFO": {
                        "EDIT": {
                            "DIALOG": {
                                "ERROR": {
                                    "REQUIRED": "Not all required fields have been completed",
                                    "EMAIL": "Invalid email address"
                                }
                            }
                        }
                    },
                    "PASSWORD": {
                        "EDIT": {
                            "DIALOG": {
                                "ERROR": {
                                    "REQUIRED": "Not all required fields have been completed",
                                    "DIFFERENT": "Passwords are different",
                                    "MINLENGTH": "Minimum 8 characters"
                                }
                            }
                        }
                    }
                },
                "OFFICE": {
                    "LABEL": "My office",
                    "EDIT": {
                        "DIALOG": {
                            "ERROR": {
                                "REQUIRED": "Not all required fields have been completed",
                                "IBAN": "Invalid IBAN",
                                "COMPANY_NUMBER": "Invalid company registration number"
                            }
                        }
                    }
                },
                "USERS": {
                    "LABEL": "Users"
                },
                "ISABEL_CONNECT": {
                    "LABEL": "Isabel Connect",
                    "CONNECTED": "Isabel Connect is active",
                    "INFO": {
                        "TITLE": "Via Isabel Connect, you establish a connection between ROOV Business and Isabel 6.",
                        "FEATURE_1": "To use Isabel Connect, only a one-time setup is required.",
                        "FEATURE_2": "All accounts from your Isabel 6 account are automatically available in ROOV Business.",
                        "FEATURE_3": "You can prepare payments from ROOV Business in Isabel 6."
                    },
                    "CONNECT": "Set up Isabel Connect"
                },
                "CATEGORIES": {
                    "LABEL": "Categories"
                }
            },
            "ACCOUNT": {
                "PERSONAL_INFO": {
                    "HEADER": "Personal data",
                    "FIRSTNAME": "First name",
                    "LASTNAME": "Last name",
                    "EMAIL": "Email"
                },
                "PASSWORD": {
                    "HEADER": "Password",
                    "INFO": "Logging into ROOV Business is done with your email address and a password",
                    "EDIT": {
                        "TITLE": "Change password"
                    },
                    "OLD_PASSWORD": {
                        "HEADER": "Enter your current password to set a new one",
                        "LABEL": "Current password"
                    },
                    "NEW_PASSWORD": {
                        "HEADER": "Choose new password",
                        "LABEL": "New password",
                        "CONFIRM_PASSWORD": "Repeat password"
                    }
                }
            },
            "OFFICE": {
                "GENERAL": {
                    "HEADER": "General",
                    "NAME": "Office name",
                    "LANGUAGE": "Language",
                    "ADDRESS": {
                        "STREET": "Street",
                        "NUMBER": "No. / box",
                        "POSTAL_CODE": "Postal code",
                        "CITY": "Municipality"
                    },
                    "COMPANY_NUMBER": "Company registration number"
                },
                "BANK_ACCOUNTS": {
                    "HEADER": "Bank accounts",
                    "PREFIX": "This helps to recognize transactions between the client and you and automatically assign them to the correct category.",
                    "IBAN": "IBAN",
                    "ADD_ACCOUNT": "Add account"
                },
                "COURTS": {
                    "HEADER": "Courts",
                    "PREFIX": "The default court set here is assumed for clients where no court is set.",
                    "JUSTICE_PEACE": "Default justice of the peace",
                    "LABOUR_COURT": "Default labour court",
                    "NO_JUSTICE_PEACE": "No default justice of the peace",
                    "NO_LABOUR_COURT": "No default labour court"
                },
                "LOGO": {
                    "HEADER": "Logo",
                    "ADD": "Add logo",
                    "EDIT": "Update logo",
                    "CLEAR": "Clear logo"
                },
                "CC_ACCESS": {
                    "HEADER": "Access to my office",
                    "TOGGLE": {
                        "LABEL": "Authorize ROOV to access my office for support"
                    },
                    "NOT_GRANTED": "Authorization was not granted.",
                    "GRANTED": "Authorization was granted by {{ user }} on {{ date }}.",
                    "REVOKED": "Authorization was revoked by {{ user }} on {{ date }}."
                }
            },
            "USERS": {
                "FILTER": {
                    "SHOW_BLOCKED": {
                        "LABEL": "Blocked users"
                    }
                },
                "COLUMN": {
                    "NAME": {
                        "HEADER": "Name"
                    },
                    "EMAIL": {
                        "HEADER": "Email"
                    },
                    "DEFAULT": {
                        "HEADER": "Default"
                    }
                },
                "DEFAULT": {
                    "ADMINISTRATOR": "Administrator",
                    "DEBT_MEDIATOR": "Debt mediator"
                },
                "BLOCKED": "Blocked",
                "ACTIONS": {
                    "EDIT": "Edit",
                    "SET_DEFAULT_ADMINISTRATOR": "Default administrator",
                    "SET_DEFAULT_DEBT_MEDIATOR": "Default debt mediator",
                    "BLOCK": "Block",
                    "UNBLOCK": "Unblock",
                    "REVOKE_INVITATION": "Revoke invitation"
                },
                "BUTTON": {
                    "ADD": {
                        "LABEL": "Invite user"
                    }
                },
                "DIALOG": {
                    "ADD": {
                        "TITLE": "New user"
                    },
                    "EDIT": {
                        "TITLE": "Edit user"
                    },
                    "ERROR": {
                        "REQUIRED": "Not all required fields have been completed",
                        "EMAIL": "Invalid email address"
                    }
                },
                "PERSONAL": {
                    "TITLE": "Personal data",
                    "FIRSTNAME": "First name",
                    "LASTNAME": "Last name",
                    "EMAIL": "Email"
                },
                "ROLE": {
                    "TITLE": "User role",
                    "ADMIN": {
                        "LABEL": "Admin",
                        "DESCRIPTION": "This role allows to manage the users of this office"
                    }
                },
                "EMPTY": "No users found",
                "INVITED": "Invited"
            },
            "CATEGORIES": {
                "LABEL": "Categories",
                "BUTTON": {
                    "ADD": "Add category"
                },
                "FILTERS": {
                    "MAIN": {
                        "ALL": "All main categories"
                    },
                    "CUSTOM": {
                        "LABEL": "Custom categories only"
                    },
                    "MAPPING": {
                        "NONE": "Select a judicial district"
                    }
                },
                "ACTIONS": {
                    "EDIT": "Edit",
                    "DELETE": "Delete"
                },
                "MAIN": {
                    "LABEL": "Main category"
                },
                "SUB": {
                    "LABEL": "Subcategory"
                },
                "TABLE": {
                    "EMPTY": "No categories found"
                },
                "DIALOG": {
                    "ADD": {
                        "TITLE": "New category",
                        "CATEGORY": {
                            "TITLE": "Category"
                        }
                    },
                    "ERROR": {
                        "REQUIRED": "Category is required",
                        "DUPLICATE": "This category already exists"
                    },
                    "EDIT": {
                        "TITLE": "Edit category",
                        "CATEGORY": {
                            "TITLE": "Category"
                        }
                    },
                    "DELETE": {
                        "TITLE": "Delete category",
                        "CATEGORY": {
                            "TITLE": "Category"
                        },
                        "REASSIGN": {
                            "TITLE": "Recategorize transactions",
                            "DETAILS": "assign {{ count }} transactions with this category to:",
                            "CATEGORY": {
                                "PLACEHOLDER": "Select a category"
                            },
                            "DETAILS_EMPTY": "There are no transactions with this category",
                            "DETAILS_SINGLE": "assign 1 transaction with this category to:"
                        },
                        "USED_IN_CLIENT_BUDGET": {
                            "TITLE": "Included in budget plans",
                            "INFO": "This category is included in the budget plans of the clients listed below and therefore cannot be removed."
                        }
                    }
                },
                "MAPPING": {
                    "LABEL": "Corresponding categories for reporting",
                    "CRBP": {
                        "LABEL": "CRBP / RCPP"
                    },
                    "HONORARIUM": {
                        "LABEL": "Honorarium"
                    }
                }
            }
        },
        "EDIT_PAYMENT_DIALOG": {
            "TITLE": "Edit payment"
        },
        "XS2A": {
            "TITLE": "Add bank account / renew authorization",
            "FINANCIAL_INSTITUTION": {
                "TITLE": "Bank"
            },
            "INSTRUCTIONS": {
                "TITLE": "Instructions",
                "REDIRECT_TO_BANK": "When you click “Confirm,” you will be redirected to the bank's portal.",
                "AUTHENTICATE": "Sign in at the bank (card reader, itsMe...).",
                "SELECT_ALL": "Select all accounts you want to synchronize with ROOV Business (new and previously added).",
                "SELECT_ONE": "Select the account you want to add to ROOV Business or renew authorization for.",
                "CONFIRM_SELECTION": "Confirm your selection.",
                "CONFIRM_GLOBAL": "Confirm access to all accounts.",
                "REDIRECT_TO_ROOV": "You will be taken back to ROOV Business.",
                "SELECT_FINANCIAL_INSTITUTION": "Select the bank",
                "GKCCBEBB": "Select the accounts (max. 100) you wish to add or renew authorization for.",
                "GEBABEBB": "Select the accounts you wish to add or renew authorization for.",
                "BBRUBEBB": "Select the accounts (max. 50) you want to add or renew authorization for.",
                "CLICK_NEXT": "Click “Next.” You will be presented with a form.",
                "ENTER_CUSTOMER_REFERENCE": "If requested, enter your bank customer number.",
                "ENTER_IBANS": "Enter the IBANs of the new accounts you want to add (leave blank if you only want to renew the authorization of previously added accounts).",
                "CONFIRM_TO_REDIRECT_TO_BANK": "Click “Confirm.” You will be redirected to the bank's portal.",
                "CONFIRM_DETAILED": "Confirm that you are giving ROOV / Augias Corp. access to the accounts.",
                "ENTER_IBANS_FOR_IMPORT": "Select the IBANs of the accounts for which you want to import the history.",
                "SELECT_ALL_FOR_IMPORT": "Select the accounts for which you want to import the history, as well as the accounts you want to continue synchronizing.",
                "SELECT_ONE_FOR_IMPORT": "Select the account for which you want to import the history.",
                "GKCCBEBB_FOR_IMPORT": "Select the accounts (max. 100) for which you want to import the history.",
                "GEBABEBB_FOR_IMPORT": "Select the accounts for which you want to import the history.",
                "BBRUBEBB_FOR_IMPORT": "Select the accounts (max. 50) for which you want to import the history."
            },
            "IMPORTANT": {
                "TITLE": "Important",
                "FINANCIAL_INSTITUTION_OFFERED_1": "Do not select only the new accounts you want to add or the accounts for which you want to renew authorization. Select all the accounts you want to synchronize with ROOV Business.",
                "FINANCIAL_INSTITUTION_OFFERED_2": "If you do not reselect an account that you previously added, it will no longer synchronize and will receive an error status.",
                "GLOBAL": "With this bank, you cannot choose which accounts to link. All accounts to which you have the necessary permissions are automatically added.",
                "SINGLE_1": "Authorization can only be granted for 1 account at a time.",
                "SINGLE_2": "Repeat the process for each account you want to add or renew authorization for.",
                "GKCCBEBB_ERROR": "At Belfius, an error message may occur when too many accounts are selected at once. Normally it is possible to select up to ±100 accounts.",
                "GKCCBEBB_RETRY": "If you still get an error message, try again with fewer accounts.",
                "REPEAT": "Repeat the process until all your accounts have been added or renewed.",
                "GEBABEBB_ERROR": "A common error message with BNP Paribas Fortis, Fintro and Hello bank! is “List of accounts not available”. This can be solved in most cases by going to your local BNP Paribas Fortis branch and having your eID read to update your personal data.",
                "BBRUBEBB_LIMIT": "ING allows you to select up to 50 accounts at once. Conveniently, the list of accounts is divided into pages of exactly 50 accounts.",
                "KREDBEBB": "A common problem with KBC / CBC is that not all accounts are visible. This indicates that the permissions on those accounts are not sufficient (power of attorney is not sufficient, holder is needed). To resolve this, you need to contact the local KBC / CBC office to adjust the permissions.",
                "DETAILED_1": "The bank is not only asked for authorization for new accounts. Renewed authorization is also requested for all previously added accounts. This is necessary because otherwise those accounts would no longer synchronize and would receive an error status.",
                "DETAILED_2": "If you no longer have access to a previously added account or it has been closed in the meantime, that account must be archived before performing this process. Otherwise, the entire process will fail.",
                "DETAILED_1_FOR_IMPORT": "Are there accounts that have not yet been synchronized via Isabel Connect? Then a new authorization will be requested from the bank for those accounts as well. This is necessary because otherwise those accounts would no longer synchronize and would receive an error status.",
                "DETAILED_2_FOR_IMPORT": "If you no longer have access to any of the accounts mentioned in the previous point, or if such an account has since been closed, then that account must be archived before performing this process. Otherwise, the entire process will fail.",
                "FINANCIAL_INSTITUTION_OFFERED_1_FOR_IMPORT": "Are there accounts that have not yet been synchronized via Isabel Connect? Then select these accounts as well.",
                "FINANCIAL_INSTITUTION_OFFERED_2_FOR_IMPORT": "If you do not reselect such an account mentioned in the previous point, it will no longer synchronize and will receive an error status.",
                "GLOBAL_FOR_IMPORT": "With this bank, you cannot choose which accounts to import. All accounts to which you have the necessary permissions are automatically authorized.",
                "SINGLE_2_FOR_IMPORT": "Repeat the process for each account for which you want to import the history.",
                "REPEAT_FOR_IMPORT": "Repeat the process until the history is imported for all accounts for which you want it."
            },
            "ERROR": {
                "REQUIRED": "Not all required fields have been completed",
                "IBAN": "Invalid IBAN"
            },
            "CUSTOMER_REFERENCE": {
                "LABEL": "Customer number",
                "INFO": "Enter your customer number from {{ bank }}."
            },
            "IBANS": {
                "LABEL": "New accounts",
                "INFO": "Enter the IBANs of the new accounts you want to add.",
                "PLACEHOLDER": "IBAN",
                "ADD": "Add account"
            },
            "ACTIVE_ACCOUNTS": {
                "LABEL": "Previously added accounts",
                "INFO": "List of previously added accounts for which a new authorization is requested.",
                "LABEL_FOR_IMPORT": "Other accounts",
                "INFO_FOR_IMPORT": "List of accounts that were not yet synchronized via Isabel Connect and for which a new authorization is requested."
            },
            "IMPORT": {
                "TITLE": "Import history"
            },
            "ACCOUNTS_FOR_IMPORT": {
                "LABEL": "Accounts to import",
                "INFO": "Select the accounts for which you want to import the history."
            }
        },
        "XS2A_REDIRECT": {
            "FI_ERROR": {
                "TITLE": "Authorization failed",
                "INFO": "The bank provided the following info:",
                "ERROR": "Error",
                "ERROR_DESCRIPTION": "Error description",
                "WHAT_NOW": {
                    "TITLE": "Now what?",
                    "INFO_1": "Did you cancel the process yourself? Then just start again.",
                    "INFO_2": "Were you unable to log in to the bank? Possibly there is a temporary problem at the bank and you can try again later. If the problem persists, there is probably something wrong with your customer settings at the bank. Please contact your bank branch.",
                    "INFO_3": "Did you get an error message at the bank after logging in? In most cases, this indicates no or insufficient access to one or more accounts for which you are trying to grant authorization.\u2028 Do you know which account(s) are affected? Then restart the process without those account(s) or contact your bank branch to adjust the permissions on the account(s).",
                    "INFO_4": "Have you tried everything, but it still doesn't work? Send us all useful information (customer number at the bank, IBANs you want to authorize, address and screenshot of the error page at the bank). We will ask the bank what is going wrong."
                },
                "NO_AUTH": "No authorization was granted."
            },
            "AIAR_AUTH_ERROR": {
                "TITLE": "Retrieval of account info failed",
                "INFO": "Something went wrong while retrieving the accounts for which authorization was granted.\n\n\nThe bank provided us with a code for the successful authorization of your accounts for access from ROOV Business.\n\nHowever, when retrieving those accounts from the bank using the provided code, things went wrong.\n\nThus, the process was not completed. No accounts were added and/or the authorization of the accounts was not renewed.",
                "WHAT_NOW": {
                    "TITLE": "Now what?",
                    "INFO_1": "Possibly there is a temporary problem at the bank. It is worth trying again at a later time.",
                    "INFO_2": "Does this problem persist? Send us all useful info (customer number at the bank, IBANs you want to authorize, address and screenshot of this page). We will ask the bank what is going wrong."
                }
            },
            "LOADING": "Processing...",
            "AIAR_AUTH": {
                "TITLE": "Successful authorization",
                "ACCOUNTS": "Authorization was successfully granted for the following account(s):",
                "SYNCING": "Synchronization of balance and transactions has started.",
                "IMPORTANT": {
                    "TITLE": "Important",
                    "INFO_1": "It may take some time for account info to be fully synchronized, especially for newly added accounts or when authorization was granted for a large number of accounts.",
                    "INFO_2": "The history available varies from bank to bank. Most banks provide the last 1, 2 or 5 years. In a few cases, this is limited to 3 or 6 months."
                }
            },
            "TITLE": "Account authorization"
        },
        "ISABEL_REDIRECT": {
            "TITLE": "Set up Isabel Connect",
            "ISABEL_ERROR": {
                "TITLE": "Authorization failed",
                "NO_AUTH": "No connection was established.",
                "INFO": "Isabel 6 provided the following info:",
                "ERROR": "Error",
                "ERROR_DESCRIPTION": "Error description"
            },
            "LOADING": "Processing...",
            "AUTH_ERROR": {
                "TITLE": "Connecting to Isabel 6 failed.",
                "INFO": "Something went wrong when connecting to Isabel 6.\n\n\nIsabel 6 provided us with a code for the successful connection with ROOV Business.\n\nHowever, when validating the delivered code, things went wrong.\n\nThus, the process was not completed."
            },
            "CONNECTED": {
                "TITLE": "Isabel Connect is active"
            },
            "AUTHORIZED": {
                "SYNCING": "Synchronization of balance and transactions has begun.",
                "IMPORTANT": {
                    "INFO_1": "It may take a while for the account info to be fully synchronized.",
                    "INFO_2": "By default, new accounts in Isabel 6 receive no history from the bank and only become available via Isabel Connect as soon as a new transaction is performed. We are currently asking banks to provide 2 years of history for all accounts.",
                    "TITLE": "Important"
                }
            }
        },
        "DOCUMENT_PAYMENT_DIALOG": {
            "TITLE": "Pay document"
        },
        "DIALOG": {
            "QUEUED_ITEMS": {
                "SINGLE": "1 item to go",
                "MULTI": "{{count}} items to go"
            }
        },
        "PROCESS_DOCUMENT_DIALOG": {
            "TITLE": "Process document",
            "BUTTON": {
                "PAY": {
                    "LABEL": "Pay"
                },
                "ASSIGN": {
                    "LABEL": "Assign"
                }
            },
            "ERROR": {
                "REQUIRED": "Not all required fields have been completed",
                "REMITTANCE_INFORMATION": "Invalid payment reference",
                "MAT_DATEPICKER_MIN": "The execution date cannot be in the past",
                "MAT_DATEPICKER_PARSE": "Invalid date",
                "MIN": "The amount should be greater than 0",
                "EDITING": "Beneficiary must first be saved",
                "IBAN": "Invalid IBAN",
                "UNIQUE": "An account with this IBAN already exists",
                "BENEFICIARY_NAME": "Invalid name",
                "SAME_IBAN": "Le numéro de compte du bénéficiaire est le même que celui du paiement",
                "MAT_DATEPICKER_MAX": "The execution date cannot be more than one year in the future",
                "DOCUMENT_NAME_EDITING": "Name needs to be saved first"
            },
            "DELETE": {
                "TITLE": "Delete document"
            }
        },
        "CC_ACCESS": {
            "MESSAGE": "You are logged in as {{ user }} in the office &quot;<strong>{{ office }}</strong>&quot;",
            "BUTTON": {
                "LABEL": "Close session"
            }
        },
        "TRANSACTION_CATEGORIES": {
            "MAIN_CATEGORY_SUFFIX": {
                "TRANSFERS_IN": " (incoming)",
                "TRANSFERS_OUT": " (outgoing)"
            }
        }
    },
    "NAVBAR": {
        "COLOR_MODE": {
            "dark": "Dark mode",
            "light": "Light mode",
            "system": "Follow system"
        }
    },
    "PAGINATOR": {
        "FIRST_PAGE_LABEL": "First page",
        "ITEMS_PER_PAGE_LABEL": "Éléments per page",
        "LAST_PAGE_LABEL": "Last page",
        "NEXT_PAGE_LABEL": "Next page",
        "PREVIOUS_PAGE_LABEL": "Previous page",
        "EMPTY_RANGE_LABEL": "no items",
        "RANGE_LABEL_OF": "of"
    },
    "SEARCH_FIELD": {
        "PLACEHOLDER": "Search"
    },
    "FILTER_FIELD": {
        "PLACEHOLDER": "Filter"
    },
    "STATUS": {
        "ACTIVE": "Active",
        "ARCHIVED": "Archived"
    },
    "SELECT_FIELD": {
        "SEARCH": "Search",
        "NOT_FOUND": "No items found"
    },
    "MAINTENANCE": {
        "TITLE": "Maintenance in progress",
        "MESSAGE": "Sorry for the inconvenience but we're performing some maintenance at the moment. We'll be back online shortly!"
    },
    "PDF_VIEWER": {
        "NEXT_PAGE": "Next page",
        "PREVIOUS_PAGE": "Previous page"
    },
    "LOGOUT": {
        "TITLE": "Goodbye",
        "MESSAGE": "Your session has ended. Close this window or log in again to ROOV Business.",
        "BUTTON": "Log in again"
    },
    "AUTH": {
        "LOADING": "Loading authorization"
    },
    "DOCUMENT_VIEWER": {
        "ZOOM_OUT": "Zoom out",
        "ZOOM_IN": "Zoom in",
        "ZOOM_1": "Zoom to 100%",
        "ZOOM_FIT_WIDTH": "Zoom to fit width"
    }
}